import {
  Flex,
  Skeleton,
  IconButton,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useColorMode,
  useDisclosure,
  Text
} from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import useIsMobile from 'lib/hooks/useIsMobile'
import config from 'configs/app'
import useApiQuery from 'lib/api/useApiQuery'
import { HOMEPAGE_STATS } from 'stubs/stats'
import TextSeparator from 'ui/shared/TextSeparator'

import { getEnvValue } from '../../../configs/app/utils';
interface TypeGasFeeVanary {
  data: any
  isLoading: boolean
  isError: boolean
}
const fetchGasFeeVanaryData = async () => {
  const response = await fetch(getEnvValue('NEXT_PUBLIC_GAS_VANARY_PRICE') ?? '')
  const data = await response.json()
  return data
}
const tierTable = {
  holder: {
    textAlign: 'left',
  },
  innerColumn: {
    padding: '10px'
  }
}
const TopBarStats = () => {
  const isMobile = useIsMobile()
  const { data, isPlaceholderData, isError } = useApiQuery('homepage_stats', {
    queryOptions: {
      placeholderData: HOMEPAGE_STATS,
      refetchOnMount: false
    }
  })
  const {
    data: gasFees,
    isLoading: isLoadingGasFeeDataa,
    isError: gasFeeError
  }: TypeGasFeeVanary = useQuery({
    staleTime: 12000,
    queryKey: ['gas_fees_vanary'],
    queryFn: fetchGasFeeVanaryData
  })

  // if (isError) {
  //   return <div />
  // }

  return (
    <Flex alignItems="center" fontSize="xs" fontWeight={500}>
      <Skeleton isLoaded={!isLoadingGasFeeDataa}>
        <Popover
          placement="bottom-start"
          isLazy
          trigger="hover"
          // placement={isMobile ? 'bottom-end' : 'right-start'}
          offset={[-8, 8]}>
          <PopoverTrigger>
            <Text
              as="span"
              fontSize="sm"
              color="blue.400"
              fontWeight={700}
              px="10px"
              mx="2px"
              cursor={'pointer'}>
              Gas Tiers
            </Text>
          </PopoverTrigger>
          <PopoverContent overflowY="hidden" w="auto" fontSize="sm">
            <PopoverBody boxShadow="2xl" p={5}>
              <table style={{ textAlign: 'left' }}>
                <thead>
                  <tr>
                    <th style={tierTable.innerColumn}>Gas Tier</th>
                    <th style={tierTable.innerColumn}>Gas Range (Gwei)</th>
                    <th style={tierTable.innerColumn}>Gas fee (VANRY)</th>
                    <th style={tierTable.innerColumn}>USD Value</th>
                  </tr>
                </thead>
                <tbody style={{ marginTop: '10px' }}>
                  {gasFees?.data?.map((row: any, index: number) => (
                    <tr key={index}>
                      <td style={tierTable.innerColumn}>Tier {row.tier}</td>
                      <td style={tierTable.innerColumn}>{row.gas_range_gwei}</td>
                      <td style={tierTable.innerColumn}>{row.tx_fee}</td>
                      <td style={tierTable.innerColumn}>{row.usd_value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Skeleton>
      {data?.coin_price && (
        <Skeleton isLoaded={!isPlaceholderData}>
          <span>{config.chain.governanceToken.symbol || config.chain.currency.symbol}: </span>
          <span>
            $
            {Number(data.coin_price).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 6
            })}
          </span>
        </Skeleton>
      )}
      {data?.coin_price && config.UI.homepage.showGasTracker && <TextSeparator color="divider" />}
      {data?.gas_prices && config.UI.homepage.showGasTracker && (
        <Skeleton isLoaded={!isPlaceholderData}>
          <span>Gas: {data.gas_prices.average} Gwei</span>
        </Skeleton>
      )}
    </Flex>
  )
}

export default React.memo(TopBarStats)
